import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { createSignedRequest } from 'utils/createSignedRequest';
import Config from 'Config';

export const putProjectToMergeInto = createAsyncThunk(
  'projects/putProjectToMergeInto',
  async (keyOfProjectToMergeInto, { getState, rejectWithValue }) => {
    const state = getState();

    const selectedProjectId = state?.root?.project?.id;

    if (!selectedProjectId) {
      throw new Error('No project selected');
    }

    if (!keyOfProjectToMergeInto) {
      throw new Error('Project is required in putProjectToMergeInto thunk');
    }
    const apiPath = `projects/${selectedProjectId}/put-project-to-merge-into`;

    const request = {
      //url: `http://localhost:3001/${apiPath}`,
      url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
      host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
      path: apiPath,
      method: 'PATCH',
      region: Config.AWS_REGION,
      service: 'execute-api',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ keyOfProjectToMergeInto }), // aws4 looks for body; axios for data
      data: { keyOfProjectToMergeInto },
    };
    const signedRequest = await createSignedRequest(request);

    let response;
    try {
      response = await axios(signedRequest);
    } catch (e) {
      return rejectWithValue({ errorMessage: e.response.data.message });
    }

    return response.data;
  }
);
